import classNames from "classnames";

import { FeedbackSentiment } from "@/shared/domain/agentThread";
import { ThumbsDown, ThumbsUp } from "@/shared/foundation/icons";

import styles from "./FeedbackSentimentIcon.module.css";

/** Green thumbs-up or red thumbs-down for a feedback row's sentiment. */
export function FeedbackSentimentIcon({
  sentiment,
}: {
  sentiment: FeedbackSentiment;
}) {
  const isPositive = sentiment === FeedbackSentiment.POSITIVE;
  const Icon = isPositive ? ThumbsUp : ThumbsDown;
  // role="img" with aria-hidden={false} exposes the label to screen readers
  // without a hover tooltip (which a <title> would add).
  return (
    <Icon
      role="img"
      aria-hidden={false}
      aria-label={isPositive ? "Positive" : "Negative"}
      className={classNames(
        styles.icon,
        isPositive ? styles.positive : styles.negative,
      )}
    />
  );
}
